// imports
import { useAtom } from "jotai";
import {  useCallback, useRef, useState } from 'react';

// lib files
import { locateAtom } from "@/lib/atoms/location-verification";

// styles
import styles from './GetLocateCode.module.scss';

async function fetchLocateCodeForStation(stationId: string) {
  const url = `/api/v1/locate/getcode/?stationId=${stationId}`
  const response = await fetch(url)
  const json = await response.json()
  return json
}

// This component is a developer convenience to get locate codes
// for testing the locate flow. It should not appear in production.
const GetLocateCode = () => {
  const [ locateState, setLocateState ] = useAtom(locateAtom);
  const inputRef = useRef<HTMLInputElement>(null);

  const [locateCodeStatus, setLocateCodeStatus] = useState<'idle' | 'loading' | 'invalidId' | 'error' | 'success'>('idle');
  const [code, setCode] = useState<string | null>(null);

  const GetACodeAnyCode = useCallback(async (stationId: string) => {
    try {
      const resp = await fetchLocateCodeForStation(stationId);
      switch(true) {
        case !resp.status && resp.code !== undefined:
          setCode(resp.code);
          return setLocateCodeStatus('success');
        case resp.status === 'error':
        default:
          return setLocateCodeStatus('error');
      }
    } catch (_error) {
      return setLocateCodeStatus('error');
    }
  }, [])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const stationId = inputRef && inputRef?.current?.value;

    if (stationId && stationId.length > 10) {
      setLocateCodeStatus('loading');
      GetACodeAnyCode(stationId);
    } else {
      setLocateCodeStatus('invalidId');
    }
  };

  const handleUseValue = (code: string) => {
    setLocateState({
      ...locateState,
      devLocateCode: code,
    });
  }

  return (
    <>
    <p className={styles.get_locate_code__intro}>For internal use:</p>
    <div className={styles.get_locate_code}>
      { locateCodeStatus === 'idle' && (
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Enter Station Id" ref={inputRef} required />
          <button type="submit">Get Locate Code</button>
        </form>
      )}

      { locateCodeStatus === 'loading' && (
        <>⌛️ Loading...</>
      )}

      { locateCodeStatus === 'invalidId' && (
        <>⛔️ Invalid Station Id <button type="button" onClick={() => { setLocateCodeStatus('idle')}}>Try Again</button></>
      )}

      { locateCodeStatus === 'error' && (
        <>⛔️ Error <button type="button" onClick={() => { setLocateCodeStatus('idle')}}>Try Again</button></>
      )}

      { locateCodeStatus === 'success' && code && (
        <>
          ✅ Success: {code}
          <button type="button" onClick={() => { handleUseValue(code)}}>
            Use
          </button>
          <button type="button" onClick={() => { setLocateCodeStatus('idle')}}>
            Get Another
          </button>
        </>
      )}
    </div>
    </>
  );
};

export default GetLocateCode;
